import React, { FC, HTMLProps } from 'react';
import DOMPurify from 'dompurify';

// for security
// eslint-disable-next-line @typescript-eslint/no-explicit-any
DOMPurify.addHook('afterSanitizeAttributes', (node: any) => {
  if (node.target === '_blank') node.setAttribute('rel', 'noopener noreferrer');
});

type RawHTMLProps = React.HTMLAttributes<HTMLOrSVGElement> & {
  // eslint-disable-next-line react/require-default-props
  tag?: keyof JSX.IntrinsicElements;
  children: string;
};

const RawHTML: FC<HTMLProps<HTMLSpanElement> & RawHTMLProps> = ({
  children,
  tag: Tag = 'span',
  ...props
}: RawHTMLProps) => (
  <Tag
    {...props}
    dangerouslySetInnerHTML={{
      __html: DOMPurify.sanitize(children, { ADD_ATTR: ['target'] }),
    }}
  />
);

export default RawHTML;
